import type { FC } from 'react';
import React, { useCallback, useState } from 'react';
import { ServicesOverviewTableViewOverviewTableView } from './ServicesOverviewTableView';
import {
  useDeleteLineItemConfigurationPhoenix,
  useGetTaxLineConfigurationsPhoenix,
} from '@pflegenavi/service-provider-frontend/api';
import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';
import { useErrorSnackbar } from '@pflegenavi/web-components';
import { useGetGlobalServiceProviderId } from '../../hooks/useGetGlobalServiceProviderId';

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
interface ServicesOverviewTableTableProps {}

export const ServicesOverviewTableTable: FC<
  ServicesOverviewTableTableProps
> = () => {
  const { enqueueSnackbar } = useSnackbar();
  const { enqueueErrorSnackbar } = useErrorSnackbar();
  const { t } = useTranslation();

  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(5);

  const { globalServiceProviderId } = useGetGlobalServiceProviderId();
  const { data, isLoading } = useGetTaxLineConfigurationsPhoenix(
    globalServiceProviderId
  );

  const { mutateAsync: deleteTaxLineConfig } =
    useDeleteLineItemConfigurationPhoenix(globalServiceProviderId);

  const handleDeleteTaxLineConfig = useCallback(
    async (id: string) => {
      try {
        await deleteTaxLineConfig({ id });
        enqueueSnackbar(
          t('service-provider-page.services.delete-modal.success-to-delete'),
          { variant: 'success' }
        );
      } catch (error) {
        enqueueErrorSnackbar(
          error,
          t('service-provider-page.services.delete-modal.failed-to-delete')
        );
      }
    },
    [deleteTaxLineConfig, enqueueErrorSnackbar, enqueueSnackbar, t]
  );

  return (
    <ServicesOverviewTableViewOverviewTableView
      data={data ?? []}
      page={page}
      pageSize={pageSize}
      onChangePage={setPage}
      onChangePageSize={setPageSize}
      isLoading={isLoading}
      handleDeleteTaxLineConfig={handleDeleteTaxLineConfig}
    />
  );
};
